module.exports = __webpack_public_path__ + "img/discovery.4727f764.svg";